import { useEffect } from 'react';
import { useAppContext } from '../hooks/context/AppContext';
import { useProfileApi } from '../Services/api/profileApi';
import { useLoader } from './common/LoaderContext';
import { errorToast } from "../Utils/toast";

const UserInitializer = () => {
  const {authData, updateUserData, setUserInitialized  } = useAppContext();
  const { getProfile } = useProfileApi();
  const { setLoading } = useLoader();
  
  useEffect(() => {
    const fetchUserProfile = async () => {
      setLoading(true);
      try {
        const res = await getProfile();
        if (res) {
          updateUserData(res);
        }
      } catch (err) {
        console.error('Failed to fetch user profile', err);
        errorToast("Failed to fetch user profile")
      } finally {
        setUserInitialized(true);
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [authData]);

  return null; // no UI
};

export default UserInitializer;
